import { Controller } from 'stimulus'
import Modal from 'bootstrap/js/src/modal'

const COOKIE = 'popup_message_first_seen'

export default class extends Controller {
  static values = { delay: Number }

  connect () {
    let firstSeen = this.readCookie()
    if (!firstSeen) {
      firstSeen = Date.now()
      this.writeCookie(firstSeen)
    }

    // Count down from the first-ever visit, not this page load — so the delay
    // accrues across navigations and browser restarts, then stays shown forever.
    const remaining = firstSeen + this.delayValue * 1000 - Date.now()
    this.timeout = setTimeout(() => {
      Modal.getOrCreateInstance(this.element).show()
    }, Math.max(0, remaining))
  }

  disconnect () {
    clearTimeout(this.timeout)
  }

  readCookie () {
    const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE}=(\\d+)`))
    return match ? Number(match[1]) : null
  }

  writeCookie (value) {
    // ponytail: 400d is Chrome's max cookie lifetime — "permanent" enough.
    // Bump COOKIE name to re-trigger the countdown for returning visitors.
    document.cookie = `${COOKIE}=${value}; path=/; max-age=${400 * 24 * 60 * 60}; samesite=lax`
  }
}
